import { PatientPrimaryInfoProps } from '../interface/interface';
import InfoField from './InfoField';
import { transformPhoneNumber } from '../utils/transformPhoneNumber.ts';
import { WrapEmail } from './WrapEmail.tsx';
import { WrapAddress } from './WrapAddress.tsx';

const PatientInfoPatientView = (props: PatientPrimaryInfoProps) => {
  const unformattedPhoneNumber = props.patient?.phone?.mobile;
  const formattedPhoneNumber = unformattedPhoneNumber
    ? transformPhoneNumber(unformattedPhoneNumber)
    : '-';
  return (
    <>
      {props.patient && (
        <div className="bg-secondary-pink-50 px-5 md:px-10 pt-4 pb-11 rounded-md shadow-sm">
          <div className="flex flex-col md:flex-row md:justify-between md:items-center">
            <h3 className="text-xl md:text-2xl text-primary-blue-500 font-semibold mb-2 md:mb-0">
              Patient Information
            </h3>
          </div>
          <div className="bg-white mt-3 px-4 md:px-9 pt-8 pb-2 rounded-md flex flex-row flex-wrap">
            <InfoField
              className="text-sm md:text-base"
              label="First Name"
              value={props.patient.firstName}
            />
            <InfoField
              className="text-sm md:text-base"
              label="Last Name"
              value={props.patient.lastName}
            />
            <InfoField
              label="Shipping Address"
              className="break-words"
              value={<WrapAddress address={props.patient?.address} className="text-sm md:text-base" />}
            />
            <InfoField
              label="Patient Email"
              className="break-words"
              value={<WrapEmail email={props.patient?.email ?? '-'} className="text-sm md:text-base" />}
            />
            <InfoField
              className="text-sm md:text-base"
              label="Patient Phone"
              value={formattedPhoneNumber}
            />
          </div>
        </div>
      )}
    </>
  );
};
export default PatientInfoPatientView;
